module.exports = __webpack_public_path__ + "static/logo-318e7c9a2b66507d5652d962b5127384.svg";